export const manageProjectsTableCols = [
  { accessorKey: "name", header: "Project Name" },
  { accessorKey: "type", header: "Type" },
  { accessorKey: "status", header: "Status" },
  { accessorKey: "plant", header: "Plant" },
  { accessorKey: "createdAt", header: "Created At" },
];
